import $ from 'jquery';
import BaseController from 'chairisher/_controller';
import RepeatingScroller from 'chairisher/component/scroller/repeating';

/**
 * Controller that binds actions for the new and custom page
 */
class NewAndCustomController extends BaseController {
    /** @inheritDoc * */
    bindPageActions() {
        super.bindPageActions();

        const $carouselEl = $('.js-carousel');
        if ($carouselEl.length) {
            RepeatingScroller.createProductScroller($carouselEl);
        }
    }
}

export default NewAndCustomController;
